// TODO: Move this to the @udemy-v2/utils package
export function isObject(value: unknown): value is object {
    return typeof value === 'object' && value !== null && !Array.isArray(value);
}
